import defaultAttributes from '../defaultAttributes';

const Option = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M3 3h6l6 18h6' }], ['path', { d: 'M14 3h7' }]],
];

export default Option;
